<ul class="grid row">
    <li *ngFor="let model of models" [class.active]="current.modelId === model.id"  class="col-3"> 
        <figure (click)="selectModel(model.id)">
            <span class="media">
                <img *ngIf="model.img !== ''" [src]="'assets/img/'+model.img" [alt]="model.title">
                <span class="state">
                    <svg class="icon-action-select-thumb" aria-hidden="true">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
                    </svg>
                </span>
            </span>
            <figcaption>
                {{ model.title }}
            </figcaption>
        </figure>
    </li>
</ul>
<div class="text-center">
    <label class="bt-text" (click)="selectModel(0)">{{ "need_mapping.no_choice.info" | translate }}</label>
</div>